import React from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { isProd } from "../../lib/cnb/env";

const GaWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA!, { testMode: !isProd });
  }, []);

  React.useEffect(() => {
    const currentPath = location.pathname + location.search;
    ReactGA.send({ hitType: "pageview", page: currentPath });
  }, [location]);

  return <>{children}</>;
};

export default GaWrapper;
